import 'apps/pathways/styles/start/components/search-and-filter-results.scss';
import React from 'react';
import { resolve } from 'library/helpers/path-resolver';
import Search from 'library/components/form-elements/search';
import Checklist from 'library/components/form-elements/checklist';
//import MultiSelect from 'library/components/form-elements/multi-select';
import Collapsable from 'library/components/collapsable';
import PropTypes from 'prop-types';
import PrefSvg from 'library/icons/preferences.svg';
import {
  GoogleMapsAutocomplete,
  CustomLocation,
} from 'library/components/google-maps-api';
import withData from 'util/hoc/with-data';
import { format_number } from 'library/helpers/numbers';
import { capitalize } from 'library/helpers/text';
import MultiSelect from 'library/components/form-components/multi-select';

const SingleValue = (value, job_fam) => {
  if (Array.isArray(value) && value.length === 1) {
    return value[0];
  }

  if (
    value == null ||
    typeof value === 'undefined' ||
    job_fam.length === value.length ||
    value.length === 0
  ) {
    return 'ANY';
  }

  return 'Multiple';
};

class SearchAndFilterResults extends React.Component {
  state = {
    collapsed: true,
  };

  handleCollapsable = (save) => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
    save ? null : this.props.handleOnClose();
  };

  render() {
    const {
      preferences,
      onChange,
      graph_data,
      multSelectChange,
      save,
      clear,
      handleFilter,
      loading,
      hideEditPreferences,
      industry,
    } = this.props;

    const { collapsed } = this.state;

    return (
      <div className="pathways-results-search-and-filter">
        <Search
          name="title"
          value={resolve(preferences, 'title', '')}
          onChange={handleFilter}
        />
        <div className="pathways-results-filter">
          <Checklist
            onChange={handleFilter}
            value={preferences.only}
            name="only"
            className="pathways-results-filter-liked"
          >
            <span aria-label="likes" value={'likes'}>
              LIKED
            </span>
            <span aria-label="dislikes" value={'dislikes'}>
              DISLIKED
            </span>
            <span aria-label="all" value={'all'}>
              ALL
            </span>
          </Checklist>
          <div className="pathways-results-filter-visible">
            <label>
              Education:
              <span>
                {capitalize(resolve(preferences, 'education', null)) || 'ANY'}
              </span>
            </label>
            <label>
              Industry:
              <span>
                {SingleValue(
                  resolve(preferences, 'industry', null),
                  resolve(graph_data, 'job_families', [])
                ) || 'ANY'}
              </span>
            </label>
            <label>
              Salary:
              <span>{`${
                format_number(resolve(preferences, 'min_salary', null)) || 'ANY'
              }+`}</span>
            </label>
            <label>
              Location:
              <span>{resolve(preferences, 'location_name', 'ANY')}</span>
            </label>
          </div>
          <a
            disabled={loading}
            href="javascript:void(0)"
            onClick={loading ? null : () => this.handleCollapsable(false)}
          >
            <PrefSvg style={{ transform: 'translateY(.2em)' }} />
            EDIT PREFERENCES
          </a>
        </div>
        <Collapsable
          className="pathways-results-filter-options"
          collapsed={collapsed}
        >
          <div className="pathways-results-filter-options-inner">
            <label htmlFor="education">
              Minimum Education
              <select
                aria-label="education"
                name="education"
                value={resolve(preferences, 'education', '')}
                onChange={onChange}
              >
                <option value="">No Preference</option>
                <option value="high-school">High School</option>
                <option value="associates">Associates</option>
                <option value="bachelors">Bachelors</option>
                <option value="masters">Masters</option>
                <option value="doctorate">Doctorate</option>
              </select>
            </label>
            <label htmlFor="location">
              Desired Location
              <GoogleMapsAutocomplete
                aria-label="location"
                placeholder="Use my Current Location"
                value={
                  new CustomLocation(
                    resolve(preferences, 'location_name', ''),
                    resolve(preferences, 'lat', null),
                    resolve(preferences, 'long', null)
                  )
                }
                name="location"
                onChange={onChange}
              />
            </label>
            <label htmlFor="min_salary">
              Desired Salary
              <select
                aria-label="min_salary"
                name="min_salary"
                value={resolve(preferences, 'min_salary', '')}
                onChange={onChange}
              >
                <option value="">Any</option>
                <option value="30000">$30,000+</option>
                <option value="40000">$40,000+</option>
                <option value="50000">$50,000+</option>
                <option value="60000">$60,000+</option>
                <option value="70000">$70,000+</option>
                <option value="80000">$80,000+</option>
              </select>
            </label>
            <a
              onClick={() => this.handleCollapsable()}
              href="javascript:void(0)"
            >
              close
            </a>
            {hideEditPreferences ? null : (
              <label htmlFor="industry">
                Desired Industries
                <MultiSelect
                  name="industry"
                  options={resolve(graph_data, 'job_families', [])}
                  handleChange={multSelectChange}
                  selected={industry}
                />
              </label>
            )}
          </div>

          <div className="pathways-results-filter-options-footer">
            <button onClick={clear}>clear</button>
            <button
              onClick={() => {
                save();
                this.handleCollapsable(true);
              }}
            >
              Close
            </button>
          </div>
        </Collapsable>
      </div>
    );
  }
}

SearchAndFilterResults.propTypes = {
  preferences: PropTypes.object,
  onChange: PropTypes.func,
  graph_data: PropTypes.object,
  multSelectChange: PropTypes.func,
  save: PropTypes.func,
  clear: PropTypes.func,
  queryPreferences: PropTypes.object,
  handleOnClose: PropTypes.func,
  handleFilter: PropTypes.func,
  loading: PropTypes.bool,
  hideEditPreferences: PropTypes.bool,
};

SearchAndFilterResults.query = `{
  job_families {
    id
    title
  }
}`;

export default withData(SearchAndFilterResults);
